import { colorSystem, generateThemeObjects } from './colorSystem';

export const contentData = {
  hero: {
    tag: "Chicago's LGBTQ+ News Source Since 1985",
    title: "Reach 120,000+ Engaged Readers Monthly",
    description: "Connect with Chicago's LGBTQ+ community through the region's most trusted news source – 40 years of award-winning journalism reaching progressive professionals, community advocates, and decision-makers",
    ctaText: "Advertise With Us",
    stats: [
      { key: "120K+", value: "Monthly Visitors" },
      { key: "900K", value: "Monthly Page Views" },
      { key: "40", value: "Years of Trust" }
    ]
  },
  
  audience: {
    title: "Chicago's Most Engaged LGBTQ+ Audience",
    description: "Our readers trust Windy City Times for comprehensive LGBTQ+ news, local politics, arts & culture, and community events",
    demographicsCharts: [
      {
        title: "Reader Demographics by Age",
        items: [
          { label: "18–24", percentage: 15 },
          { label: "25–34", percentage: 25 },
          { label: "35–44", percentage: 20 },
          { label: "45–54", percentage: 20 },
          { label: "55–64", percentage: 15 },
          { label: "65+", percentage: 5 }
        ]
      }
    ],
    smallStats: [
      { value: "50%", label: "Female readers" },
      { value: "45%", label: "Male readers" },
      { value: "70%", label: "Mobile users" },
      { value: "35%", label: "College graduates" },
      { value: "85%", label: "Market share" }
    ]
  },

  testimonials: {
    title: "Award-Winning Journalism",
    description: "Recognized by leading journalism organizations for excellence in LGBTQ+ reporting",
    testimonials: [
      { 
        name: "NLGJA Awards", 
        title: "2023", 
        company: "National Lesbian and Gay Journalists Association", 
        quote: "Excellence in Journalism - Recognized for outstanding coverage of LGBTQ+ issues and community stories.",
        result: "Award Winner",
        metric: "Journalism Excellence"
      },
      { 
        name: "Peter Lisagor Awards", 
        title: "2022", 
        company: "Chicago Headline Club", 
        quote: "Local Journalism - Honored for impactful reporting on Chicago's LGBTQ+ community and local issues.",
        result: "Award Winner",
        metric: "Local Journalism"
      },
      { 
        name: "Studs Terkel Award", 
        title: "2021", 
        company: "Community Media Workshop", 
        quote: "Community Service - Celebrated for dedication to community storytelling and civic engagement.",
        result: "Award Winner",
        metric: "Community Service"
      },
      { 
        name: "Chicago LGBT Hall of Fame", 
        title: "2020", 
        company: "Chicago LGBT Hall of Fame", 
        quote: "Community Recognition - Inducted for 35+ years of service to Chicago's LGBTQ+ community.",
        result: "Hall of Fame",
        metric: "Community Recognition"
      },
      { 
        name: "Andrew Davis", 
        title: "Executive Editor", 
        company: "Windy City Times", 
        quote: "For 40 years, we've been the trusted voice of Chicago's LGBTQ+ community. Our award-winning journalism continues to inform, inspire, and advocate.",
        result: "40 Years",
        metric: "Community Trust"
      }
    ]
  },

  inventory: {
    title: "Digital Advertising Solutions",
    description: "Reach Chicago's LGBTQ+ community through our comprehensive digital platform and engaged newsletter subscribers.",
    tabs: [
      {
        id: "website",
        label: "Website Display",
        isActive: true,
        title: "Premium Website Advertising",
        description: "Connect with 120,000+ monthly visitors through premium ad placements on windycitytimes.com – Chicago's leading LGBTQ+ news destination.",
        stats: [
          { value: "Billboard", label: "970x250 - $1,000/mo" },
          { value: "Leaderboard", label: "728x90 - $1,000/mo" },
          { value: "Rectangle", label: "300x250 - $500/mo" },
          { value: "Filmstrip", label: "300x600 - $700/mo" }
        ]
      },
      {
        id: "newsletters",
        label: "Email Newsletters",
        isActive: true,
        title: "Newsletter Advertising",
        description: "Reach engaged subscribers through our suite of newsletters including News on Q (45% open rate) and Chicago Social Butterflies (54% open rate).",
        stats: [
          { value: "News on Q", label: "5,000 subscribers weekly" },
          { value: "Social Butterflies", label: "54% open rate" },
          { value: "BLACKlines", label: "Black LGBTQ+ community" },
          { value: "En La Vida", label: "Latino LGBTQ+ community" }
        ]
      },
      {
        id: "sponsored",
        label: "Sponsored Content",
        isActive: true,
        title: "Native & Sponsored Content",
        description: "Custom content creation that authentically connects your brand with our LGBTQ+ readership through editorial-style storytelling.",
        stats: [
          { value: "Custom", label: "Content creation available" },
          { value: "Native", label: "In-content placement" },
          { value: "Editorial", label: "Professional writing" },
          { value: "Reach", label: "900K monthly impressions" }
        ]
      },
      {
        id: "events",
        label: "Event Sponsorships",
        isActive: true,
        title: "40th Anniversary Events",
        description: "Align your brand with our milestone 40th anniversary celebration throughout 2025 – premium visibility with Chicago's LGBTQ+ community.",
        stats: [
          { value: "Title", label: "$5,000 sponsorship" },
          { value: "Presenting", label: "$2,500 sponsorship" },
          { value: "Supporting", label: "$1,000 sponsorship" },
          { value: "Attendees", label: "200+ per event" }
        ]
      }
    ]
  },

  campaign: {
    title: "Build Your LGBTQ+ Campaign",
    description: "Connect with Chicago's LGBTQ+ community through trusted journalism and authentic community engagement.",
    planningCard: {
      title: "Start Your Campaign",
      features: [
        "CONNECT: Share your goals for reaching LGBTQ+ audiences",
        "CUSTOMIZE: We'll create a multi-channel package", 
        "CONVERT: Build brand loyalty with engaged readers"
      ],
      ctaText: "Get Started"
    }
  },

  contactFAQ: {
    contactTitle: "Connect With Chicago's LGBTQ+ Community",
    contactDescription: "Ready to reach Chicago's LGBTQ+ community through award-winning journalism? Contact our team to create your campaign.",
    contactInfo: {
      phone: "(773) 871-7610",
      email: "terri@windycitymediagroup.com",
      address: "5315 N Clark St, Suite 192, Chicago, IL 60640"
    },
    faqTitle: "Frequently Asked Questions",
    faqItems: [
      {
        question: "What makes Windy City Times unique?",
        answer: "We're Chicago's only LGBTQ+ news source with a 40-year legacy – established trust, community loyalty, and award-winning journalism that readers rely on."
      },
      {
        question: "What advertising formats do you offer?",
        answer: "We offer website display ads (billboard, leaderboard, rectangle, filmstrip), newsletter placements, sponsored content, and event sponsorships."
      },
      {
        question: "What are your minimum commitments?",
        answer: "Most digital advertising requires a 4-week minimum commitment. Event sponsorships and custom packages vary – contact us for details."
      },
      {
        question: "What's your audience demographic?",
        answer: "120,000 monthly visitors, 70% mobile, with strong representation across ages 25-54. Our readers are LGBTQ+ individuals, allies, progressive professionals, and community advocates."
      },
      {
        question: "Do you offer package discounts?",
        answer: "Yes! Our Digital Starter Package (website + newsletter) offers 12% savings, and our Premium Omnichannel Package offers up to 18% savings."
      },
      {
        question: "What's your lead time for campaigns?",
        answer: "We require 5 business days minimum lead time and materials 3 business days prior to publication. Rush placements may be available – contact us."
      }
    ]
  },

  aboutUs: {
    title: "40 Years of LGBTQ+ Journalism",
    description: "Windy City Media Group has been Chicago's trusted LGBTQ+ news source since 1985. Our award-winning journalism covers local politics, community events, arts and culture, healthcare, and social justice issues that matter to Chicago's LGBTQ+ community. Led by Executive Editor Andrew Davis and Publisher Terri Klinsky, our team includes veteran journalists like Matt Simonette, Rex Wockner, and Richard Knight Jr. We've earned recognition from the National Lesbian and Gay Journalists Association, Chicago Headline Club, and induction into the Chicago LGBT Hall of Fame. As we celebrate our 40th anniversary in 2025, we continue our mission: informing, inspiring, and advocating for Chicago's LGBTQ+ community.",
    imageUrl: "/aboutus.png"
  },

  footer: {
    contactInfo: {
      phone: "(773) 871-7610",
      email: "terri@windycitymediagroup.com", 
      address: "5315 N Clark St, Suite 192, Chicago, IL 60640"
    },
    socialLinks: {
      linkedin: "https://facebook.com/WindyCityTimes",
      twitter: "https://twitter.com/WindyCityTimes",
      facebook: "https://facebook.com/WindyCityTimes"
    },
    companyName: "Windy City Media Group",
    description: "Chicago's trusted LGBTQ+ news source since 1985 – 40 years of award-winning journalism"
  }
};

export const themeData = {
  // Design system values
  gradStart: colorSystem.darkGradient.start,
  gradEnd: colorSystem.darkGradient.end,
  angle: colorSystem.darkGradient.angle,
  fontFamily: "primary",
  radius: 4,
  iconWeight: "duotone",
  
  // Assets
  imageUrl: "/hero-new.png",
  logoUrl: `/images/wcmlogo-white.webp?v=${Date.now()}`,
  
  // Navigation
  navItems: [
    { id: "audience", label: "Our Audience", href: "#audience" },
    { id: "advertise", label: "Advertise", href: "#inventory" },
    { id: "aboutus", label: "About", href: "#aboutus" }
  ],
  ctaText: "Contact",
  ctaHref: "#contactfaq",
  
  // Section settings
  sectionSettings: {
    hero: { surface: "white", primary: "light" },
    audience: { surface: "light", primary: "light" },
    testimonials: { surface: "dark", primary: "dark" },
    inventory: { surface: "light", primary: "light" },
    campaign: { surface: "dark", primary: "dark" },
    contactfaq: { surface: "light", primary: "light" },
    aboutus: { surface: "light", primary: "light" },
    footer: { surface: "dark", primary: "dark" }
  },
  
  // Theme colors - now generated from centralized system
  ...generateThemeObjects()
};
